import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { AuthState } from '../../auth-state';
import { AuthService } from '../../auth.service';
import { HomeController } from 'src/app/modules/home/home.controller';
import { GeneralService } from 'src/app/shared/services/general.service';

@Component({
  selector: 'app-authenticator',
  templateUrl: './authenticator.component.html',
  styleUrls: ['./authenticator.component.scss']
})
export class AuthenticatorComponent implements OnInit, OnDestroy {

  authState: AuthState;

  params:any;

  data:any = {};

  constructor(
    protected gs: GeneralService,
    private authService: AuthService, 
    private renderer: Renderer2,
    protected control : HomeController
    ) {
      
      this.authState = this.authService.getActualAuthState();
      this.renderer.addClass(document.body, 'page-auth');
  }

  ngOnInit() {
    if(this.params?.email)
      this.data.email = this.params?.email;

    if(this.params?.returnUrl)
      this.gs.returnUrl = this.params?.returnUrl;

    this.subscribe();
    this.authState = this.authService.getActualAuthState();
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'page-auth');
  }

  subscribe() {
    this.authService.getAuthStateChange()
      .subscribe(state => {
        this.authState = state;
      });
  }
}